import(/* webpackMode: "eager" */ "/home/devops/azure-agent/_work/2/s/apps/platform-admin/src/app/(auth)/login/login.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/home/devops/azure-agent/_work/2/s/apps/platform-admin/src/app/(auth)/login/LoginForm.tsx");
